import { useState, useRef } from 'react';
// @mui
import { IconButton, Box, Stack, Typography } from '@mui/material';
// components
import { CoreTimePopoverComponent } from './';
import Iconify from '../../components/Iconify';
// ----------------------------------------------------------------------

export default function CoreTimePopover({ sx }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        ref={menuRef}
      >
        <Iconify icon={"eva:info-fill"} sx={{ width: 20, height: 20, color: (theme) => theme.palette.grey[500] }} />
      </IconButton>

      <CoreTimePopoverComponent
        open={Boolean(open)}
        anchorEl={menuRef.current}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1,
        }}
      >
        <Box sx={{ p: 1.5 }}>
          <Stack spacing={1.5}>
          <Stack>
            <Typography variant="subtitle2" noWrap>
              '코어 타임'이 무엇인가요?
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              크루가 출퇴근 시스템을 이용하기로 약속한 시간입니다.
            </Typography>
          </Stack>
          <Stack>
            <Typography variant="subtitle2" noWrap>
              왜 설정 하나요?
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              회사와 크루가 쉽게 소통하기 위해 설정합니다.
            </Typography>
          </Stack>
          </Stack>
        </Box>
      </CoreTimePopoverComponent>
    </>
  );
}
